<template>
  <div class="row">
    <div class="col-lg-12" style="padding: 20px">
      <div class="main-card mb-12 card" style="margin-left: 10px">
        <div style="margin: 0 20px 20px 20px">
          <ul style="color: #000">
            <li
              v-for="(includes, board) in boards"
              :class="{ active: selBoard === board }"
              v-on:click="
                selBoard = board;
                loadBoard();
              "
              v-bind:key="board"
              style="font-size:20px;important;font-weight:bold;"
            >
              <a href="#" data-toggle="tab">{{ board }}</a>
            </li>
          </ul>
          <div class="tab-content">
            <div id="home">
              <h5 class="card-title">
                아이디 사용현황
                <div
                  class="sub_title"
                  style="
                    margin-bottom: 20px;
                    color: #333;
                    font-size: 13px;
                    border: 1px solid #ccc;
                    background: #f8f8f8;
                    height: 30px;
                    text-align: right;
                    position: absolute;
                    right: 20px;
                    top: 10px;
                    padding: 2px 10px;
                  "
                >
                  통계관리 → 아이디 사용현황
                </div>
              </h5>
              <query-grid :config="config" ref="qg">
                <template #items="props">
                  <tr 
                    v-for="article in props.records"
                    v-bind:key="article.s_int"
                  >
                    <td scope="col" style="text-align: center; width:30px;">
                      <p v-if="article.pname !='합계'">{{ article.sInt }}</p>

                    </td>
                    <!-- <td scope="col" style="text-align: center">
                      <Business v-if="article.parent" :biz="article.parent" />
                    </td>
                    <td scope="col" style="text-align: center">
                      <Business
                        v-if="article.searchvalue"
                        :biz="article.searchvalue"
                      />
                    </td> -->
                    <td scope="col" style="text-align: center">
                      {{ article.pname }}
                    </td>
                    <td scope="col" style="text-align: center">
                      {{ article.pyear }}년
                    </td>
                    <td scope="col" style="text-align: center">
                      {{ article.pdateFormat }}
                    </td>
                    <td scope="col" style="text-align: center; width:40px" v-for="week in 52" :key="week">
                      {{ article[`week${week}`] }}
                    </td>
                  </tr>
                </template>
              </query-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import QueryGrid from "../components/QueryGrid_fr.vue";
import Business from "../components/Business";
export default {
  components: {
    QueryGrid,
    Business,
  },
  data: () => ({
    boards: {},
    articles: [],
    selBoard: "",
    search: "",
    firstlists: [],
    firstselected: "1",
    subselected: "",
    sublists: [],
    volselected: "",
    vollists: [],
    config: {
      name: "통계관리 매출",
      req_endpoint: "/admin/stat_fr_new",
      default_limit: 20,
      search_fields: [
        {
          id: "cate_filter_sub",
          name: "년도",
          type: "select",
          filter_type: {
            '2024': "2024년",
            '2025': "2025년",
            '2026': "2026년",
            },
        },
      ],
      columns: [
        {
          id: "id",
          name: "번호",
          excel_print: (v) => {
            return v.sInt;
          },
        },
        // {
        //   id: "parent",
        //   name: "본부",
        //   excel_print: (v) => {
        //     return v.parent.name;
        //   },
        // },
        {
          id: "pname",
          name: "캠퍼스명",
          excel_print: (v) => {
            return v.pname;
          },
        },
        {
          id: "pyear",
          name: "년도",
          excel_print: (v) => {
            return v.pyear;
          },
        },
        {
          id: "pdateFormat",
          name: "갱신날짜",
          excel_print: (v) => {
            return v.pdateFormat;
          },
        },
        ...Array.from({ length: 52 }, (_, i) => ({
          id: `week${i + 1}`,
          name: `${i + 1}주`,
          excel_print: (v) => v[`week${i + 1}`],
        })),
      ],
    },
  }),
  methods: {
    
    loadBoard() {
     
      if (this.search) {
        extras += "&search=" + this.search;
      }
      if (this.subselected) {
        extras += "&cate_filter_type=sub&cate_filter_var=" + this.subselected;
      } else if (this.firstselected) {
        extras +=
          "&cate_filter_type=main&cate_filter_var=" + this.firstselected;
      }
      axios.get("/admin/stat_id" + extras).then((response) => {
        if (response.data.error) {
          alert("ID 메출을 집계 할 수 없습니다.\n" + response.data.error);
        } else {
          this.articles = response.data.result.articles;
        }
      });
    },
    viewSecond() {
      this.$refs.qg.pushSetting("cate_filter_sub", null);
      this.subselected = null;
      axios
        .get("/admin/sub_categories/" + this.firstselected)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.sublists = response.data.result;
          }
        });
    },
  },
  mounted() {
    //this.loadBoard()
    //this.filter_values['cate_filter_sub'] = '2025';
    //console.log(this.filter_values[cate_filter_sub] );
    axios.get("/admin/sub_categories").then((response) => {
      if (response.data.error) {
        $.notify(
          {
            // options
            message: "데이터를 조회할 수 없습니다. " + response.data.error,
          },
          {
            // settings
            type: "danger",
            z_index: 9999,
          }
        );
      } else {
        this.firstlists = response.data.result;
        //console.log(this.firstlists);
      }
    });
  },
};
</script>
